* {
  box-sizing: border-box;
}

:host {
  display: block;
  position: relative;
}

$horizontal_padding: calc(4 * var(--spacer));
$vertical_padding: calc(5 * var(--spacer));

.sso-integration-widget-wrapper {
  display: flex;
  gap: 16px;
}

.card {
  &--wrapper {
    max-width: 50%;
    flex-grow: 1;
  }
  &--content {
    padding: $vertical_padding $horizontal_padding;

    &.no-description-card {
      align-items: center;
      text-align: center;

      .card--title-wrap {
        display: flex;
        flex-direction: column;

        .icon {
          margin-right: 0;
        }

        .card--title {
          margin-top: var(--spacer);
          color: var(--body-text-arrows-400);
        }
      }

      .card--action-button {
        margin-top: calc(2 * var(--spacer));
      }
    }
  }

  &--intro {
    margin-top: var(--spacer);
    color: var(--body-text-arrows-400);
  }
}
